import { BaseService } from "src/Shared/Services/Base.service";
import { CompanyRevenueApiUrl } from "../Tools/CompanyRevenueApiUrls";
import { ICompanyRevenue } from "../Interfaces/ICompanyRevenue";
import { IResult } from "src/Shared/Interfaces";
import { ICompanyAdditionalRevenueStream } from "../Interfaces/ICompanyAdditionalRevenueStream";

class CompanyRevenueService extends BaseService {
  public getCompanyRevenue(companyRowID: string) {
    return this.http.get<ICompanyRevenue[] | null>(
      CompanyRevenueApiUrl.GetRevenue(companyRowID)
    );
  }

  public addOrEditAdditionalRevenueStream(
    request: ICompanyAdditionalRevenueStream
  ) {
    return this.http.post<IResult<string>>(
      CompanyRevenueApiUrl.AdditionalStream,
      request
    );
  }

  public deleteCompanyAdditionalRevenueStream(
    companyAdditionalRevenueStreamID: number
  ) {
    return this.http.delete<IResult<string>>(
      CompanyRevenueApiUrl.AdditionalStream +
        `?companyAdditionalRevenueStreamID=${companyAdditionalRevenueStreamID}`,
      {}
    );
  }
}

export default new CompanyRevenueService();
